module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slides-area"
  }, [_c('div', {
    staticClass: "wrapword"
  }, [_c('carousel', {
    attrs: {
      "autoplay": true,
      "autoplayTimeout": _vm.autoplayTimout,
      "autoplayHoverPause": true,
      "navigationEnabled": true,
      "perPage": 1
    }
  }, [_vm._l((_vm.getImages), function(image, index) {
    return _c('slide', {
      key: index,
      style: (image.styles)
    }, [_c('button', {
      staticClass: "btn btn-default skip-btn",
      attrs: {
        "type": "button",
        "title": _vm.$t('Skip'),
        "name": "skip"
      },
      on: {
        "click": _vm.skipSlide
      }
    }, [_vm._v(" X ")]), _vm._v(" "), _c('div', {
      staticClass: "slider-image"
    }, [_c('img', {
      attrs: {
        "src": image.img,
        "alt": image.title
      }
    })])])
  }), _vm._v(" "), _vm._l((_vm.$store.getters.getCurrentSlides.slides), function(slide, index) {
    return _c('slide', {
      key: index,
      style: (slide.style)
    }, [_c('button', {
      staticClass: "btn btn-default skip-btn",
      attrs: {
        "type": "button",
        "title": _vm.$t('Skip'),
        "name": "skip"
      },
      on: {
        "click": _vm.skipSlide
      }
    }, [_vm._v(" X ")]), _vm._v(" "), _c('div', {
      staticClass: "label",
      attrs: {
        "dir": "ltr"
      }
    }, _vm._l((_vm.seperatedSentences(_vm.$t(slide.text))), function(text) {
      return _c('p', {
        staticClass: "sentence",
        attrs: {
          "dir": "ltr"
        }
      }, [_vm._v(_vm._s(text))])
    }))])
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-652fb008"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slides.vue
// module id = 311
// module chunks = 1